"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfidTagConfigReducer = exports.rfidTagConfigAction = exports.rfidTagConfigTypes = exports.rfidTagHaulerTypes = exports.rfidTagHaulerReducer = exports.rfidTagHaulerAction = exports.rfidTagDumpTruckTypes = exports.rfidTagDumpTruckReducer = exports.rfidTagDumpTruckAction = void 0;
// root rfid tag component
const rfid_tag_1 = __importDefault(require("./rfid-tag"));
const rfid_tag_action_1 = __importDefault(require("./rfid-tag.action"));
exports.rfidTagConfigAction = rfid_tag_action_1.default;
const rfid_tag_reducer_1 = __importDefault(require("./rfid-tag.reducer"));
exports.rfidTagConfigReducer = rfid_tag_reducer_1.default;
const rfid_tag_types_1 = require("./rfid-tag.types");
Object.defineProperty(exports, "rfidTagConfigTypes", { enumerable: true, get: function () { return rfid_tag_types_1.rfidTagConfigTypes; } });
//tab dump truck
const dump_truck_1 = require("./dump-truck");
Object.defineProperty(exports, "rfidTagDumpTruckAction", { enumerable: true, get: function () { return dump_truck_1.rfidTagDumpTruckAction; } });
Object.defineProperty(exports, "rfidTagDumpTruckReducer", { enumerable: true, get: function () { return dump_truck_1.rfidTagDumpTruckReducer; } });
Object.defineProperty(exports, "rfidTagDumpTruckTypes", { enumerable: true, get: function () { return dump_truck_1.rfidTagDumpTruckTypes; } });
//tab hauler
const hauler_1 = require("./hauler");
Object.defineProperty(exports, "rfidTagHaulerAction", { enumerable: true, get: function () { return hauler_1.rfidTagHaulerAction; } });
Object.defineProperty(exports, "rfidTagHaulerReducer", { enumerable: true, get: function () { return hauler_1.rfidTagHaulerReducer; } });
Object.defineProperty(exports, "rfidTagHaulerTypes", { enumerable: true, get: function () { return hauler_1.rfidTagHaulerTypes; } });
exports.default = rfid_tag_1.default;
